// ─────────────────────────────────────────────────────────────────────────────
// Runtime config. One build ships to every environment, so a deployed UI reads
// its API URL and Okta settings from /config.json, which the deploy writes next
// to index.html (Deployment/ui-sync/sync-ui.sh). Local dev has no such file —
// Vite answers unknown paths with index.html — so VITE_* env vars apply there.
// ─────────────────────────────────────────────────────────────────────────────

type RuntimeConfig = {
  apiBaseUrl?: string
  oktaIssuer?: string
  oktaClientId?: string
  /** `integration` or `prod` when deployed; drives the non-prod banner. */
  environment?: string
}

let loaded: RuntimeConfig = {}

const fallback: RuntimeConfig = {
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL as string | undefined,
  oktaIssuer: import.meta.env.VITE_OKTA_ISSUER as string | undefined,
  oktaClientId: import.meta.env.VITE_OKTA_CLIENT_ID as string | undefined,
  environment: (import.meta.env.VITE_APP_ENV as string | undefined) ?? 'local',
}

/** Must finish before anything that calls cfg() at module load is imported. */
export async function loadRuntimeConfig(): Promise<void> {
  try {
    const res = await fetch('/config.json', { cache: 'no-store' })
    if (res.ok && res.headers.get('content-type')?.includes('json')) {
      loaded = (await res.json()) as RuntimeConfig
    }
  } catch {
    // No runtime config: local dev.
  }
}

export function cfg(key: keyof RuntimeConfig): string | undefined {
  return loaded[key] || fallback[key]
}
